export const serverConfig = {
    url: 'https://oiqw01jn94.execute-api.us-east-1.amazonaws.com/default/graphql',
    // url: 'http://localhost:5000/graphql',
};
